import UserIcon from '@mui/icons-material/AccountBox';
import UsersList from './UsersList';
import UserEdit from './UserEdit';
import UserCreate from './UserCreate';

// eslint-disable-next-line 
export default {
    list: UsersList,
    edit: UserEdit,
    create: UserCreate,
    icon: UserIcon
};